import React from 'react';
import { AuthProvider } from './hooks/useAuth';
import { CompanyProvider } from './context/CompanyContext';
import AppRoutes from './routes/AppRoutes';
import DevToolsBlocker from './components/DevToolsBlocker'; // ✅ make sure path is correct
import './App.css';

function App() {
  return (
    <CompanyProvider>
      <AuthProvider>
        <DevToolsBlocker />  {/*✅ Add it here */}
        <AppRoutes />
      </AuthProvider>
    </CompanyProvider>
  );
}

export default App;

